import axiosInstance from "./axios";

export const fetchCustomers = async (page = 1, search = null, zone_id = null, city_id = null, per_page = 15) => {
  const response = await axiosInstance.get("/customers", {
    params: { page, per_page, search: search || undefined, zone_id: zone_id || undefined, city_id: city_id || undefined },
  });
  return response;
};

// Page adapter for AsyncAutocomplete: (page, search) => { items, hasMore }
export const fetchCustomerPage = async (page, search) => {
  const res = await fetchCustomers(page, search || null);
  const paginator = res.data ?? {};
  return {
    items: Array.isArray(paginator.data) ? paginator.data : [],
    hasMore: (paginator.current_page ?? page) < (paginator.last_page ?? 1),
  };
};

export const exportCustomers = async (search = null, zone_id = null, city_id = null) => {
  return axiosInstance.get("/customers", {
    params: { search: search || undefined, zone_id: zone_id || undefined, city_id: city_id || undefined, export: true },
    responseType: 'blob',
  });
};

export const fetchCustomerById = async (id) => {
  const response = await axiosInstance.get(`/customers/${id}`);
  return response;
};

export const createCustomer = async (data) => {
  const response = await axiosInstance.post("/customers", data);
  return response;
};

export const updateCustomer = async (id, data) => {
  const response = await axiosInstance.put(`/customers/${id}`, data);
  return response;
};

export const deleteCustomer = async (id) => {
  const response = await axiosInstance.delete(`/customers/${id}`);
  return response;
};

export const createCustomerFromLead = async (leadId, data = {}) => {
  const response = await axiosInstance.post(
    `/leads/${leadId}/create-customer`,
    data,
  );
  return response;
};
